import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PermissionService} from '../../service/permission.service';

@Component({
  selector: 'app-permission-restricted-container',
  templateUrl: './permission-restricted-container.component.html',
  styleUrls: ['./permission-restricted-container.component.scss']
})
export class PermissionRestrictedContainerComponent implements OnChanges {

  @Input() message = 'Vous n\'avez pas accès à cette fonctionnalité.';
  @Input() permission: string;
  @Input() permissions: string[] = [];
  @Input() showMessageIfNoAccess = false;
  @Input() forceNoAccess = false;
  hasAccess = false;

  constructor(private permissionService: PermissionService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.permission || changes.permissions || changes.forceNoAccess) {
      this.synchronizeHasAccess();
    }
  }

  synchronizeHasAccess() {
    if (this.forceNoAccess) {
        this.hasAccess = false;
        return;
    }

    // console.log(['synchronizeHasAccess', this.permission, this.permissions]);
    if (!this.permission && this.permissions?.length === 0) {
      this.hasAccess = true;
    } else {
      if (this.permission) {
        this.permissionService.hasPermission(this.permission)
            .then(hasPermission => {
              this.hasAccess = hasPermission;
            })
            .catch(() => this.hasAccess = false);
      } else {
        this.permissionService.hasAtLeastOnePermission(this.permissions)
            .then(hasPermission => {
              this.hasAccess = hasPermission;
            })
            .catch(() => this.hasAccess = false);
      }
    }
  }
}
